import { useFormikContext } from 'formik';
import { useEffect } from 'react';
import useFetchActivityCount from './useFetchActivityCount';
import useFetchWorkQueueSavedFilters from './useFetchWorkQueueSavedFilters';
import useFetchWorkQueueTableHeaders from './useFetchWorkQueueTableHeaders';
import useFetchWorkQueueResult from './useFetchWorkQueueResult';
import { processWorkQueueResult, transformReactFilterToLS, updateWorkQueueFilters } from '../workQueue.utils';
import { useUserPreferences } from 'App/contexts/UserPreferencesContext';
import { FILTER_TYPE } from '../workQueue.constant';

function useWorkQueue() {
    const { data: activityCount, isLoading: isActivityCountLoading } = useFetchActivityCount();
    const { data: workQueueTableHeaders, isLoading: isTableHeadersLoading } = useFetchWorkQueueTableHeaders();
    const { setPreference } = useUserPreferences();
    const {
        values,
        values: { filterParams, filterType },
        setFieldValue,
        setSubmitting,
    } = useFormikContext();

    const { data: savedFilter, isLoading: isSavedFiltersLoading } = useFetchWorkQueueSavedFilters(filterType);

    const { isLoading, data: workQueueResult } = useFetchWorkQueueResult(
        updateWorkQueueFilters(
            filterParams,
            values.allBranchesList,
            values.allCategoriesList,
            values.allActivityTypesList,
            values.allPatientLabelsList,
            values.allCustomOptionsList
        )
    );

    useEffect(() => {
        if (!isActivityCountLoading) {
            setFieldValue('result.activityCountResult', activityCount);
        }
    }, [activityCount, isActivityCountLoading, setFieldValue]);

    useEffect(() => setSubmitting(isLoading), [isLoading, setSubmitting]);

    useEffect(() => {
        if (!isTableHeadersLoading) {
            setFieldValue('result.workQueueTableHeaders', workQueueTableHeaders);
        }
    }, [workQueueTableHeaders, isTableHeadersLoading, setFieldValue]);

    useEffect(() => {
        if (!isSavedFiltersLoading && savedFilter) {
            setFieldValue('result.savedFilterResult', Object.values(savedFilter));
        }
    }, [savedFilter, isSavedFiltersLoading, setFieldValue]);

    useEffect(() => {
        if (workQueueResult) {
            setFieldValue('result.workQueueActivityCount', workQueueResult.count);
            setFieldValue('result.workQueueResult', processWorkQueueResult(workQueueResult.data));
            if (filterType !== FILTER_TYPE.ASSIGNMENT_MANAGER) {
                setPreference('workQueue_selectedFilter', transformReactFilterToLS(values));
            } else {
                setPreference('assignmentManager_selectedFilter', transformReactFilterToLS(values));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workQueueResult]);
}

export default useWorkQueue;
